<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-商品内容
    -->
  <div>
    <!--其它-->
    <div class="common-form mt50">其它</div>

    <!--抽奖规则-->
    <el-form-item label="抽奖规则：">
      <div class="edit_container">
        <Uediter :text="form.sweepstakes_content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>
    <el-form-item label="抽奖排序" :rules="[{ required: true, message: '请输入抽奖排序' }]" prop="sort">
      <div class="max-w460">
        <el-input v-model="form.sort" type="number"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="是否生效">
      <el-radio-group v-model="form.status">
        <el-radio :label="0">未生效</el-radio>
        <el-radio :label="1">生效</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 800,
          initialFrameHeight: 500
        }
      }
    };
  },
  created() {
    //console.log(this.form.sweepstakes_content,12321)
    //this.ueditor.text = this.form.model.content;
  },
  props: ['form'],
  methods:{

    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.sweepstakes_content=e;
    }

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/part/Other.vue